import React, { useState, useEffect } from 'react';

export default function SimpleSchedule() {
  const [data, setData] = useState([]);
  const [filteredGames, setFilteredGames] = useState([]);
  const [selectedTeam, setSelectedTeam] = useState('All Teams');
  const [selectedDate, setSelectedDate] = useState('All Dates');
  const [dates, setDates] = useState(['All Dates']);
  const [teams, setTeams] = useState(['All Teams']);
  const [loading, setLoading] = useState(true);
  const [teamCounts, setTeamCounts] = useState({});
  const [groupedGames, setGroupedGames] = useState({});

  // Full dataset - all 58 games
  const scheduleData = [
    {"Game Number":1,"Game Date":"May 24","Kick Off":"10:00am","Field":"Alder 1","Home Team":"Storm FC U8G","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":2,"Game Date":"May 24","Kick Off":"10:00am","Field":"Alder 2","Home Team":"Stratford Strikers U8 Girls","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":3,"Game Date":"May 24","Kick Off":"11:10am","Field":"Alder 1","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":4,"Game Date":"May 24","Kick Off":"11:10am","Field":"Alder 2","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":14,"Game Date":"May 24","Kick Off":"12:20pm","Field":"Alder 1","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Storm FC U8G"},
    {"Game Number":22,"Game Date":"May 31","Kick Off":"11:00am","Field":"Eastview Mini 4","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":21,"Game Date":"May 31","Kick Off":"11:00am","Field":"Eastview Mini 6","Home Team":"Stratford Strikers U8 Girls","Away Team":"Storm FC U8G"},
    {"Game Number":29,"Game Date":"May 31","Kick Off":"12:10pm","Field":"Eastview Mini 4","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Storm FC U8G"},
    {"Game Number":28,"Game Date":"May 31","Kick Off":"12:10pm","Field":"Eastview Mini 6","Home Team":"Stratford Strikers U8 Girls","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":33,"Game Date":"May 31","Kick Off":"1:20pm","Field":"Eastview Mini 4","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":38,"Game Date":"Jun 7","Kick Off":"10:00am","Field":"Alder 1","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Storm FC U8G"},
    {"Game Number":39,"Game Date":"Jun 7","Kick Off":"10:00am","Field":"Alder 2","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":45,"Game Date":"Jun 7","Kick Off":"11:10am","Field":"Alder 1","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":44,"Game Date":"Jun 7","Kick Off":"11:10am","Field":"Alder 2","Home Team":"Stratford Strikers U8 Girls","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":51,"Game Date":"Jun 7","Kick Off":"12:20pm","Field":"Alder 1","Home Team":"Storm FC U8G","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":60,"Game Date":"Jun 14","Kick Off":"11:00am","Field":"Cooper Standard - Douro St #5","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":58,"Game Date":"Jun 14","Kick Off":"11:00am","Field":"Cooper Standard - Douro St #6","Home Team":"Storm FC U8G","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":66,"Game Date":"Jun 14","Kick Off":"1:00pm","Field":"Cooper Standard - Douro St #5","Home Team":"Storm FC U8G","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":65,"Game Date":"Jun 14","Kick Off":"1:00pm","Field":"Cooper Standard - Douro St #6","Home Team":"Stratford Strikers U8 Girls","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":72,"Game Date":"Jun 21","Kick Off":"11:00am","Field":"Eastview Mini 4","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":71,"Game Date":"Jun 21","Kick Off":"11:00am","Field":"Eastview Mini 6","Home Team":"Storm FC U8G","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":75,"Game Date":"Jun 21","Kick Off":"12:10pm","Field":"Eastview Mini 4","Home Team":"Storm FC U8G","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":76,"Game Date":"Jun 21","Kick Off":"12:10pm","Field":"Eastview Mini 6","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":79,"Game Date":"Jun 21","Kick Off":"1:20pm","Field":"Eastview Mini 4","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":86,"Game Date":"Jul 5","Kick Off":"10:00am","Field":"Cooper Standard - Douro St #5","Home Team":"Storm FC U8G","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":87,"Game Date":"Jul 5","Kick Off":"10:00am","Field":"Cooper Standard - Douro St #6","Home Team":"Stratford Strikers U8 Girls","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":93,"Game Date":"Jul 5","Kick Off":"11:10am","Field":"Cooper Standard - Douro St #5","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":91,"Game Date":"Jul 5","Kick Off":"11:10am","Field":"Cooper Standard - Douro St #6","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Storm FC U8G"},
    {"Game Number":97,"Game Date":"Jul 5","Kick Off":"12:20pm","Field":"Cooper Standard - Douro St #5","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":106,"Game Date":"Jul 12","Kick Off":"11:00am","Field":"Eastview Mini 4","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":107,"Game Date":"Jul 12","Kick Off":"11:00am","Field":"Eastview Mini 6","Home Team":"Stratford Strikers U8 Girls","Away Team":"Storm FC U8G"},
    {"Game Number":112,"Game Date":"Jul 12","Kick Off":"12:10pm","Field":"Eastview Mini 4","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Storm FC U8G"},
    {"Game Number":113,"Game Date":"Jul 12","Kick Off":"12:10pm","Field":"Eastview Mini 6","Home Team":"Stratford Strikers U8 Girls","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":117,"Game Date":"Jul 12","Kick Off":"1:20pm","Field":"Eastview Mini 4","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":122,"Game Date":"Jul 19","Kick Off":"11:00am","Field":"Eastview Mini 4","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Storm FC U8G"},
    {"Game Number":121,"Game Date":"Jul 19","Kick Off":"11:00am","Field":"Eastview Mini 6","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":127,"Game Date":"Jul 19","Kick Off":"12:10pm","Field":"Eastview Mini 4","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":128,"Game Date":"Jul 19","Kick Off":"12:10pm","Field":"Eastview Mini 6","Home Team":"Storm FC U8G","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":133,"Game Date":"Jul 19","Kick Off":"1:20pm","Field":"Eastview Mini 4","Home Team":"Stratford Strikers U8 Girls","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":138,"Game Date":"Jul 26","Kick Off":"12:00pm","Field":"Cooper Standard - Douro St #5","Home Team":"Storm FC U8G","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":139,"Game Date":"Jul 26","Kick Off":"12:00pm","Field":"Cooper Standard - Douro St #6","Home Team":"Stratford Strikers U8 Girls","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":144,"Game Date":"Jul 26","Kick Off":"1:10pm","Field":"Cooper Standard - Douro St #5","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":143,"Game Date":"Jul 26","Kick Off":"1:10pm","Field":"Cooper Standard - Douro St #6","Home Team":"Storm FC U8G","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":150,"Game Date":"Aug 9","Kick Off":"10:00am","Field":"Alder 1","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":149,"Game Date":"Aug 9","Kick Off":"10:00am","Field":"Alder 2","Home Team":"Storm FC U8G","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":153,"Game Date":"Aug 9","Kick Off":"11:10am","Field":"Alder 1","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":154,"Game Date":"Aug 9","Kick Off":"11:10am","Field":"Alder 2","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Guelph Jr. Gryphons GU8 Red"},
    {"Game Number":159,"Game Date":"Aug 9","Kick Off":"12:20pm","Field":"Alder 1","Home Team":"Storm FC U8G","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":168,"Game Date":"Aug 16","Kick Off":"10:00am","Field":"Bechtel Park B","Home Team":"BVB IA Waterloo - GU8 Yellow","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":166,"Game Date":"Aug 16","Kick Off":"10:00am","Field":"Bechtel Park D","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Stratford Strikers U8 Girls"},
    {"Game Number":169,"Game Date":"Aug 16","Kick Off":"11:10am","Field":"Bechtel Park B","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Storm FC U8G"},
    {"Game Number":171,"Game Date":"Aug 16","Kick Off":"11:10am","Field":"Bechtel Park D","Home Team":"Stratford Strikers U8 Girls","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":175,"Game Date":"Aug 16","Kick Off":"12:20pm","Field":"Bechtel Park B","Home Team":"Storm FC U8G","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":181,"Game Date":"Aug 23","Kick Off":"10:00am","Field":"Bechtel Park A","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"BVB IA Waterloo - GU8 Yellow"},
    {"Game Number":183,"Game Date":"Aug 23","Kick Off":"10:00am","Field":"Bechtel Park B","Home Team":"Guelph Jr. Gryphons GU8 Black","Away Team":"Storm FC U8G"},
    {"Game Number":186,"Game Date":"Aug 23","Kick Off":"11:10am","Field":"Bechtel Park A","Home Team":"Stratford Strikers U8 Girls","Away Team":"Storm FC U8G"},
    {"Game Number":184,"Game Date":"Aug 23","Kick Off":"11:10am","Field":"Bechtel Park B","Home Team":"Guelph Jr. Gryphons GU8 Red","Away Team":"Guelph Jr. Gryphons GU8 Black"},
    {"Game Number":187,"Game Date":"Aug 23","Kick Off":"12:20pm","Field":"Bechtel Park A","Home Team":"Stratford Strikers U8 Girls","Away Team":"BVB IA Waterloo - GU8 Yellow"}
  ];

  // Venue information
  const venueInfo = {
    'Alder': {
      name: 'Alder Soccer Fields',
      address: '275 Alder St, Orangeville, ON L9W 5H6',
      mapsUrl: 'https://maps.google.com/?q=275+Alder+St,+Orangeville,+ON+L9W+5H6'
    },
    'Eastview Mini': {
      name: 'Eastview Community Park',
      address: '800 Watson Parkway North, Guelph, ON, Canada',
      mapsUrl: 'https://maps.google.com/?q=800+Watson+Parkway+North,+Guelph,+ON'
    },
    'Cooper Standard - Douro St': {
      name: 'Cooper Standard Douro St. Fields',
      address: '703 Douro St, Stratford, ON, N5A 3T1',
      mapsUrl: 'https://maps.google.com/?q=703+Douro+St,+Stratford,+ON,+N5A+3T1'
    },
    'Bechtel Park': {
      name: 'Bechtel Park',
      address: '185 Bridge St W, Waterloo, ON N2K 1K9',
      mapsUrl: 'https://maps.google.com/?q=185+Bridge+St+W,+Waterloo,+ON+N2K+1K9'
    }
  };

  // Helper functions
  const getLocationName = (field) => {
    if (field.includes('Alder')) return 'Alder';
    if (field.includes('Eastview Mini')) return 'Eastview Mini';
    if (field.includes('Cooper Standard')) return 'Cooper Standard - Douro St';
    if (field.includes('Bechtel Park')) return 'Bechtel Park';
    return field;
  };

  const getFieldNumber = (field, location) => {
    if (field.includes(location)) {
      return field.replace(location, '').trim();
    }
    return field;
  };

  const getShortTeamName = (fullName) => {
    if (fullName === 'BVB IA Waterloo - GU8 Yellow') return (
      <span className="flex items-center">
        <img src="/images/bvb-logo.svg" alt="BVB" className="h-4 mr-1" />
        <span>BVB IA Waterloo</span>
      </span>
    );
    if (fullName === 'Guelph Jr. Gryphons GU8 Black') return 'Gryphons Black';
    if (fullName === 'Guelph Jr. Gryphons GU8 Red') return 'Gryphons Red';
    if (fullName === 'Storm FC U8G') return 'Storm FC';
    if (fullName === 'Stratford Strikers U8 Girls') return 'Strikers';
    return fullName;
  };

  const getVeryShortTeamName = (fullName) => {
    if (fullName === 'BVB IA Waterloo - GU8 Yellow') return 'BVB';
    if (fullName === 'Guelph Jr. Gryphons GU8 Black') return 'GB';
    if (fullName === 'Guelph Jr. Gryphons GU8 Red') return 'GR';
    if (fullName === 'Storm FC U8G') return 'SFC';
    if (fullName === 'Stratford Strikers U8 Girls') return 'SS';
    return fullName;
  };

  const getTeamColor = (team) => {
    if (team === 'BVB IA Waterloo - GU8 Yellow') return 'bg-yellow-100 border-yellow-400';
    if (team === 'Guelph Jr. Gryphons GU8 Black') return 'bg-gray-100 border-gray-400';
    if (team === 'Guelph Jr. Gryphons GU8 Red') return 'bg-red-100 border-red-400';
    if (team === 'Storm FC U8G') return 'bg-blue-100 border-blue-400';
    if (team === 'Stratford Strikers U8 Girls') return 'bg-green-100 border-green-400';
    return 'bg-white border-gray-300';
  };

  // Convert time to minutes for calculations and sorting
  const convertTimeToMinutes = (timeStr) => {
    // Fix the time parsing to handle both formats like "10:00am" and "1:20pm"
    const isPm = timeStr.toLowerCase().includes('pm');
    const isAm = timeStr.toLowerCase().includes('am');
    
    // Remove am/pm and split by colon
    const cleanTime = timeStr.toLowerCase().replace('am', '').replace('pm', '');
    const [hourStr, minuteStr] = cleanTime.split(':');
    
    let hour = parseInt(hourStr);
    let minute = parseInt(minuteStr);
    
    // Convert to 24-hour format
    if (isPm && hour < 12) hour += 12;
    if (isAm && hour === 12) hour = 0;
    
    return hour * 60 + minute;
  };

  // Initialize data
  useEffect(() => {
    // Extract unique teams
    const uniqueTeams = new Set();
    scheduleData.forEach(game => {
      uniqueTeams.add(game['Home Team']);
      uniqueTeams.add(game['Away Team']);
    });
    
    // Extract unique dates
    const uniqueDates = new Set();
    scheduleData.forEach(game => {
      uniqueDates.add(game['Game Date']);
    });
    
    // Sort dates
    const monthOrder = { 'May': 5, 'Jun': 6, 'Jul': 7, 'Aug': 8 };
    const sortedDates = Array.from(uniqueDates).sort((a, b) => {
      const [monthA, dayA] = a.split(' ');
      const [monthB, dayB] = b.split(' ');
      
      if (monthOrder[monthA] !== monthOrder[monthB]) {
        return monthOrder[monthA] - monthOrder[monthB];
      }
      return parseInt(dayA) - parseInt(dayB);
    });
    
    // Calculate team counts
    const counts = {};
    Array.from(uniqueTeams).forEach(team => { counts[team] = 0; });
    scheduleData.forEach(game => {
      counts[game['Home Team']]++;
      counts[game['Away Team']]++;
    });
    
    // Group games by date and location
    const grouped = {};
    scheduleData.forEach(game => {
      const date = game['Game Date'];
      const location = getLocationName(game['Field']);
      
      if (!grouped[date]) grouped[date] = {};
      if (!grouped[date][location]) grouped[date][location] = [];
      
      grouped[date][location].push(game);
    });
    
    // Sort games by time within each location
    Object.keys(grouped).forEach(date => {
      Object.keys(grouped[date]).forEach(location => {
        grouped[date][location].sort((a, b) => {
          // Simple time comparison for sorting
          return convertTimeToMinutes(a['Kick Off']) - convertTimeToMinutes(b['Kick Off']);
        });
      });
    });
    
    // Update state
    setTeams(['All Teams', ...Array.from(uniqueTeams).sort()]);
    setDates(['All Dates', ...sortedDates]);
    setData(scheduleData);
    setFilteredGames(scheduleData);
    setTeamCounts(counts);
    setGroupedGames(grouped);
    setLoading(false);
  }, []);

  // Add a function to determine if we're on a small screen
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handle team selection
  const handleTeamSelect = (team) => {
    const newTeam = team === selectedTeam ? 'All Teams' : team;
    setSelectedTeam(newTeam);
    
    filterGames(newTeam, selectedDate);
  };

  // Handle date change
  const handleDateChange = (e) => {
    const newDate = e.target.value;
    setSelectedDate(newDate);
    
    filterGames(selectedTeam, newDate);
  };

  // Filter games and calculate wait times
  const filterGames = (team, date) => {
    let filtered = [...data];
    
    // Apply team filter
    if (team !== 'All Teams') {
      filtered = filtered.filter(game => 
        game['Home Team'] === team || game['Away Team'] === team
      );
    }
    
    // Apply date filter
    if (date !== 'All Dates') {
      filtered = filtered.filter(game => game['Game Date'] === date);
    }
    
    // Calculate wait times for team games
    if (team !== 'All Teams') {
      // First, reset wait times
      filtered.forEach(game => { game.waitTime = null; });
      
      // Group games by date
      const gamesByDate = {};
      filtered.filter(game => game['Home Team'] === team || game['Away Team'] === team)
        .forEach(game => {
          const date = game['Game Date'];
          if (!gamesByDate[date]) gamesByDate[date] = [];
          gamesByDate[date].push({...game});
        });
      
      // For each date, calculate wait times
      Object.keys(gamesByDate).forEach(date => {
        const dayGames = gamesByDate[date];
        
        if (dayGames.length > 1) {
          // Sort by time
          dayGames.sort((a, b) => {
            return convertTimeToMinutes(a['Kick Off']) - convertTimeToMinutes(b['Kick Off']);
          });
          
          // Calculate wait time between consecutive games
          for (let i = 1; i < dayGames.length; i++) {
            const prevGame = dayGames[i-1];
            const currentGame = dayGames[i];
            
            // Calculate minutes between games
            const prevMinutes = convertTimeToMinutes(prevGame['Kick Off']);
            const currentMinutes = convertTimeToMinutes(currentGame['Kick Off']);
            const waitMinutes = currentMinutes - prevMinutes;
            
            // Format wait time
            let waitTime;
            if (waitMinutes >= 60) {
              const hours = Math.floor(waitMinutes / 60);
              const mins = waitMinutes % 60;
              waitTime = `${hours}h ${mins}m`;
            } else {
              waitTime = `${waitMinutes}m`;
            }
            
            // Find game in filtered list and add wait time
            const index = filtered.findIndex(g => g['Game Number'] === currentGame['Game Number']);
            if (index !== -1) {
              filtered[index].waitTime = waitTime;
            }
          }
        }
      });
    }
    
    // Group the filtered games
    const grouped = {};
    filtered.forEach(game => {
      const date = game['Game Date'];
      const location = getLocationName(game['Field']);
      
      if (!grouped[date]) grouped[date] = {};
      if (!grouped[date][location]) grouped[date][location] = [];
      
      grouped[date][location].push(game);
    });
    
    // Sort within each group
    Object.keys(grouped).forEach(date => {
      Object.keys(grouped[date]).forEach(location => {
        grouped[date][location].sort((a, b) => {
          return convertTimeToMinutes(a['Kick Off']) - convertTimeToMinutes(b['Kick Off']);
        });
      });
    });
    
    setFilteredGames(filtered);
    setGroupedGames(grouped);
  };

  // Generate Google Calendar URL for a specific game
  const generateGoogleCalendarUrl = (game) => {
    if (!game) return '#';
    
    const isHome = game['Home Team'] === selectedTeam;
    const opponent = isHome ? game['Away Team'] : game['Home Team'];
    const location = venueInfo[getLocationName(game['Field'])];
    
    // Parse date and time
    const [month, day] = game['Game Date'].split(' ');
    const monthNum = { 'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08' }[month];
    
    // Parse time
    const timeStr = game['Kick Off'];
    const isPm = timeStr.toLowerCase().includes('pm');
    const isAm = timeStr.toLowerCase().includes('am');
      
    // Remove am/pm and split by colon
    const cleanTime = timeStr.toLowerCase().replace('am', '').replace('pm', '');
    const [hourStr, minuteStr] = cleanTime.split(':');
    
    let hour = parseInt(hourStr);
    let minute = parseInt(minuteStr);
    
    // Convert to 24-hour format
    if (isPm && hour < 12) hour += 12;
    if (isAm && hour === 12) hour = 0;
    
    // Format for Google Calendar
    const startTime = `2025${monthNum}${day.padStart(2, '0')}T${hour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}00`;
    
    // End time (1 hour later)
    let endHour = hour + 1;
    const endTime = `2025${monthNum}${day.padStart(2, '0')}T${endHour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}00`;
    
    // Build URL parameters
    const params = [
      'action=TEMPLATE',
      `text=${encodeURIComponent(`${game['Home Team']} vs ${game['Away Team']}`)}`,
      `dates=${startTime}/${endTime}`,
      `details=${encodeURIComponent(`Game #${game['Game Number']}\nField: ${game['Field']}`)}`,
      location ? `location=${encodeURIComponent(location.address)}` : ''
    ];
    
    return `https://calendar.google.com/calendar/render?${params.join('&')}`;
  };

  // Generate Apple Calendar URL for a specific game
  const generateAppleCalendarUrl = (game) => {
    if (!game) return '#';
    
    const isHome = game['Home Team'] === selectedTeam;
    const opponent = isHome ? game['Away Team'] : game['Home Team'];
    const location = venueInfo[getLocationName(game['Field'])];
    
    // Parse date and time
    const [month, day] = game['Game Date'].split(' ');
    const monthNum = { 'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08' }[month];
    
    // Parse time
    const timeStr = game['Kick Off'];
    const isPm = timeStr.toLowerCase().includes('pm');
    const isAm = timeStr.toLowerCase().includes('am');
    
    // Remove am/pm and split by colon
    const cleanTime = timeStr.toLowerCase().replace('am', '').replace('pm', '');
    const [hourStr, minuteStr] = cleanTime.split(':');
    
    let hour = parseInt(hourStr);
    let minute = parseInt(minuteStr);
    
    // Convert to 24-hour format
    if (isPm && hour < 12) hour += 12;
    if (isAm && hour === 12) hour = 0;
    
    // Format for iCal (YYYYMMDDTHHMMSS)
    const startTime = `2025${monthNum}${day.padStart(2, '0')}T${hour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}00`;
    
    // End time (1 hour later)
    let endHour = hour + 1;
    const endTime = `2025${monthNum}${day.padStart(2, '0')}T${endHour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}00`;
    
    // Build iCalendar content
    let iCalContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Soccer Schedule//EN',
      'CALSCALE:GREGORIAN',
      'BEGIN:VEVENT',
      `UID:game${game['Game Number']}@soccerschedule.com`,
      `DTSTART:${startTime}`,
      `DTEND:${endTime}`,
      `SUMMARY:${game['Home Team']} vs ${game['Away Team']}`,
      `DESCRIPTION:Game #${game['Game Number']}\nField: ${game['Field']}`,
      location ? `LOCATION:${location.address}` : '',
      'BEGIN:VALARM',
      'TRIGGER:-PT1H',
      'ACTION:DISPLAY',
      'DESCRIPTION:Game reminder',
      'END:VALARM',
      'END:VEVENT',
      'END:VCALENDAR'
    ];
    
    return `data:text/calendar;charset=utf8,${encodeURIComponent(iCalContent.join('\r\n'))}`;
  };

  // Generate Apple Calendar for all team games
  const generateAppleCalendarAll = () => {
    if (selectedTeam === 'All Teams') return "#";
    
    // Filter games for selected team
    const teamGames = filteredGames.filter(game => 
      game['Home Team'] === selectedTeam || game['Away Team'] === selectedTeam
    );
    
    // Build iCalendar content
    let iCalContent = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Soccer Schedule//EN',
      'CALSCALE:GREGORIAN'
    ];
    
    // Add each game as an event
    teamGames.forEach(game => {
      const isHome = game['Home Team'] === selectedTeam;
      const opponent = isHome ? game['Away Team'] : game['Home Team'];
      const location = venueInfo[getLocationName(game['Field'])];
      
      // Parse date and time
      const [month, day] = game['Game Date'].split(' ');
      const monthNum = { 'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08' }[month];
      
      // Parse time
      const timeStr = game['Kick Off'];
      const isPm = timeStr.toLowerCase().includes('pm');
      const isAm = timeStr.toLowerCase().includes('am');
      
      // Remove am/pm and split by colon
      const cleanTime = timeStr.toLowerCase().replace('am', '').replace('pm', '');
      const [hourStr, minuteStr] = cleanTime.split(':');
      
      let hour = parseInt(hourStr);
      let minute = parseInt(minuteStr);
      
      // Convert to 24-hour format
      if (isPm && hour < 12) hour += 12;
      if (isAm && hour === 12) hour = 0;
      
      // Format for iCal (YYYYMMDDTHHMMSS)
      const startTime = `2025${monthNum}${day.padStart(2, '0')}T${hour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}00`;
      
      // End time (1 hour later)
      let endHour = hour + 1;
      const endTime = `2025${monthNum}${day.padStart(2, '0')}T${endHour.toString().padStart(2, '0')}${minute.toString().padStart(2, '0')}00`;
      
      // Create event
      iCalContent = iCalContent.concat([
        'BEGIN:VEVENT',
        `UID:game${game['Game Number']}@soccerschedule.com`,
        `DTSTART:${startTime}`,
        `DTEND:${endTime}`,
        `SUMMARY:${selectedTeam} ${isHome ? 'vs' : '@'} ${opponent}`,
        `DESCRIPTION:Game #${game['Game Number']}\nField: ${game['Field']}`,
        location ? `LOCATION:${location.address}` : '',
        'BEGIN:VALARM',
        'TRIGGER:-PT1H',
        'ACTION:DISPLAY',
        'DESCRIPTION:Game reminder',
        'END:VALARM',
        'END:VEVENT'
      ]);
    });
    
    iCalContent.push('END:VCALENDAR');
    
    return `data:text/calendar;charset=utf8,${encodeURIComponent(iCalContent.join('\r\n'))}`;
  };

  if (loading) {
    return <div className="p-4 text-center">Loading schedule...</div>;
  }

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Soccer Schedule - U8 Girls</h1>
      <div className="text-sm text-gray-600 mb-2">
        Total: {data.length} games across {dates.length - 1} dates from May to August 2025
      </div>
      
      {/* Date Filter */}
      <div className="mb-4">
        <label htmlFor="date-filter" className="block text-sm font-medium mb-2">
          Filter by Date:
        </label>
        <select
          id="date-filter"
          value={selectedDate}
          onChange={handleDateChange}
          className="w-full md:w-64 p-2 border border-gray-300 rounded-md shadow-sm"
        >
          {dates.map(date => (
            <option key={date} value={date}>{date}</option>
          ))}
        </select>
      </div>
      
      {/* Team Filter Buttons */}
      <div className="mb-6">
        <div className="text-sm font-medium mb-2">Teams:</div>
        <div className="flex flex-wrap gap-2">
          <button 
            onClick={() => handleTeamSelect('All Teams')}
            className={`px-3 py-2 rounded-md border-2 ${
              selectedTeam === 'All Teams' 
                ? 'bg-gray-100 border-gray-400 font-bold' 
                : 'bg-white border-gray-300'
            }`}
          >
            All Teams
          </button>
          
          {teams.filter(team => team !== 'All Teams').map(team => (
            <button
              key={team}
              onClick={() => handleTeamSelect(team)}
              className={`px-3 py-2 rounded-md border-2 ${
                selectedTeam === team 
                  ? 'border-gray-400 font-bold' 
                  : 'border-gray-300'
              } ${getTeamColor(team)}`}
            >
              {getShortTeamName(team)} 
              <span className="ml-1 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none rounded-full bg-white text-gray-700">
                {teamCounts[team] || 0}
              </span>
            </button>
          ))}
        </div>
      </div>
      
      {/* Export All Games to Calendar */}
      {selectedTeam !== 'All Teams' && (
        <div className="mb-6 p-3 border border-gray-200 rounded-md bg-gray-50">
          <div className="flex items-center">
            <span className="font-medium mr-3">Export all {selectedTeam} games:</span>
            <a 
              href={generateAppleCalendarAll()}
              download="all-team-games.ics"
              className="px-3 py-1 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
            >
              Apple Calendar
            </a>
          </div>
        </div>
      )}
      
      {/* Schedule Tables */}
      <div className="overflow-x-auto">
        {Object.keys(groupedGames).length > 0 ? (
          Object.keys(groupedGames).sort((a, b) => {
            const [monthA, dayA] = a.split(' ');
            const [monthB, dayB] = b.split(' ');
            const monthOrder = { 'May': 5, 'Jun': 6, 'Jul': 7, 'Aug': 8 };
            
            if (monthOrder[monthA] !== monthOrder[monthB]) {
              return monthOrder[monthA] - monthOrder[monthB];
            }
            return parseInt(dayA) - parseInt(dayB);
          }).map(date => (
            <div key={date} className="mb-8">
              <div className="bg-gradient-to-r from-gray-200 to-gray-400 text-gray-800 p-3 rounded-lg shadow-sm mb-4">
                <div className="flex items-center mb-2">
                  <div className="mr-3 bg-white text-gray-700 rounded-full w-10 h-10 flex items-center justify-center font-bold shadow-inner">
                    {date.split(' ')[1]}
                  </div>
                  <h2 className="text-xl font-bold">
                    Saturday, {date}, 2025
                  </h2>
                </div>
                
                {Object.keys(groupedGames[date]).map(location => {
                  const venueData = venueInfo[location] || {};
                  
                  return (
                    <div key={`${date}-${location}`} className="mb-6">
                      <div className="flex flex-wrap items-center mb-3 mt-2 border-t border-gray-300 pt-2">
                        <div className="flex-1 flex flex-wrap items-center">
                          <h3 className="text-lg font-semibold text-gray-800 mr-2">{location}</h3>
                          {venueData.address && (
                            <span className="text-sm text-gray-600 mr-3">{venueData.address}</span>
                          )}
                        </div>
                        {venueData.mapsUrl && (
                          <a 
                            href={venueData.mapsUrl} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="bg-gray-200 text-gray-700 px-3 py-1 rounded-md text-sm hover:bg-gray-300 transition-colors duration-150 flex items-center whitespace-nowrap mt-1 md:mt-0"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            Directions
                          </a>
                        )}
                      </div>
                      
                      <div className="overflow-x-auto border border-gray-200 rounded-lg shadow-sm mb-4">
                        <table className="min-w-full divide-y divide-gray-200">
                          <thead className="bg-gray-800">
                            <tr>
                              <th scope="col" className="px-2 md:px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-8 md:w-12">#</th>
                              <th scope="col" className="px-2 md:px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-12 md:w-20">Field</th>
                              <th scope="col" className="px-2 md:px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-16 md:w-24">Time</th>
                              <th scope="col" className="px-2 md:px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">{isMobile ? 'Home' : 'Home Team'}</th>
                              <th scope="col" className="px-2 md:px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">{isMobile ? 'Away' : 'Away Team'}</th>
                              {selectedTeam !== 'All Teams' && (
                                <th scope="col" className="px-2 md:px-4 py-3 text-left text-xs font-medium text-white uppercase tracking-wider w-16 md:w-24">Wait</th>
                              )}
                              <th scope="col" className="px-2 md:px-4 py-3 text-center text-xs font-medium text-white uppercase tracking-wider w-24 md:w-48">Calendar</th>
                            </tr>
                          </thead>
                          <tbody className="bg-white divide-y divide-gray-200">
                            {groupedGames[date][location].map((game, index) => {
                              const isBvbHome = game['Home Team'].includes('BVB');
                              const isBvbAway = game['Away Team'].includes('BVB');
                              
                              return (
                                <tr 
                                  key={game['Game Number']} 
                                  className={`
                                    ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}
                                    hover:bg-gray-100 transition-colors duration-150
                                  `}
                                >
                                  <td className="px-2 md:px-4 py-2 md:py-3 whitespace-nowrap text-xs md:text-sm font-medium text-gray-900">{game['Game Number']}</td>
                                  <td className="px-2 md:px-4 py-2 md:py-3 whitespace-nowrap text-xs md:text-sm text-gray-700">{getFieldNumber(game['Field'], location)}</td>
                                  <td className="px-2 md:px-4 py-2 md:py-3 whitespace-nowrap text-xs md:text-sm text-gray-700">{game['Kick Off']}</td>
                                  <td className={`px-2 md:px-4 py-2 md:py-3 whitespace-nowrap text-xs md:text-sm font-medium ${isBvbHome ? 'bg-yellow-100 text-black font-bold' : 'text-gray-900'}`}>
                                    {isMobile ? getVeryShortTeamName(game['Home Team']) : getShortTeamName(game['Home Team'])}
                                  </td>
                                  <td className={`px-2 md:px-4 py-2 md:py-3 whitespace-nowrap text-xs md:text-sm font-medium ${isBvbAway ? 'bg-yellow-100 text-black font-bold' : 'text-gray-900'}`}>
                                    {isMobile ? getVeryShortTeamName(game['Away Team']) : getShortTeamName(game['Away Team'])}
                                  </td>
                                  {selectedTeam !== 'All Teams' && (
                                    <td className="px-2 md:px-4 py-2 md:py-3 whitespace-nowrap text-xs md:text-sm text-gray-700">
                                      {game.waitTime && (
                                        <span className="bg-gray-100 text-gray-700 px-1 md:px-2 py-1 rounded text-xs md:text-sm">
                                          {game.waitTime}
                                        </span>
                                      )}
                                    </td>
                                  )}
                                  <td className="px-2 md:px-4 py-2 md:py-3 whitespace-nowrap text-xs md:text-sm text-gray-700 text-center">
                                    <div className="flex items-center justify-center space-x-1 md:space-x-2">
                                      <a 
                                        href={generateGoogleCalendarUrl(game)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="bg-gray-100 text-gray-700 px-1 md:px-2 py-1 rounded-md text-xs hover:bg-gray-200 inline-flex items-center transition-colors duration-150"
                                        title="Add to Google Calendar"
                                      >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-0 md:mr-1" viewBox="0 0 20 20" fill="currentColor">
                                          <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" />
                                        </svg>
                                        <span className="hidden md:inline">Google</span>
                                      </a>
                                      <a 
                                        href={generateAppleCalendarUrl(game)}
                                        download={`game-${game['Game Number']}.ics`}
                                        className="bg-gray-100 text-gray-700 px-1 md:px-2 py-1 rounded-md text-xs hover:bg-gray-200 inline-flex items-center transition-colors duration-150"
                                        title="Add to Apple Calendar"
                                      >
                                        <svg xmlns="http://www.w3.org/2000/svg" className="h-3 w-3 mr-0 md:mr-1" viewBox="0 0 20 20" fill="currentColor">
                                          <path d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v2H7a1 1 0 100 2h2v2a1 1 0 102 0v-2h2a1 1 0 100-2h-2V7z" />
                                        </svg>
                                        <span className="hidden md:inline">Apple</span>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))
        ) : (
          <div className="p-4 text-center border rounded bg-gray-50">No games found</div>
        )}
      </div>
      
      <div className="mt-4 text-sm text-gray-600">
        Showing {filteredGames.length} of {data.length} games
        {selectedTeam !== 'All Teams' && (
          <span> for {selectedTeam}</span>
        )}
        {selectedDate !== 'All Dates' && (
          <span> on {selectedDate}</span>
        )}
      </div>
    </div>
  );
}
